<template>
   <div>
      <!-- PARTIE VISITES  -->
      <div class="container-mobile sous-titre" style="margin-top:12px">Dernières visites</div>
      <div class="spinner-container" v-if="loading">
         <BeatLoader color="#1389EF" />
      </div>
      <div v-else>
         <div v-if="visites.length == 0" class="text-center">Vous n'avez effectué aucune visite pour l'instant.</div>
         <div>
            <div class="liste">
               <div v-for="visite in visites" :key="visite.id" class="liste-item" @click="goToVisite(visite.id)">
                  <div class="flex">
                     <div class="date-liste">{{ visite.date }}</div>
                  </div>

                  <div class="liste-icones">
                     <div @click.stop="deleteVisite(visite.id)">
                        <b-icon icon="delete" class="del"></b-icon>
                     </div>
                  </div>
               </div>
            </div>
            <!-- fin table -->
         </div>
      </div>
      <!-- début pagination  -->
      <section style="margin-top:20px" class="container-mobile" v-if="pagination.last_page > 1">
         <b-pagination
            :total="pagination.total"
            :current.sync="pagination.current_page"
            :per-page="pagination.per_page"
            rounded
            order="is-centered"
            aria-next-label="Page suivante"
            aria-previous-label="Page précédente"
            aria-page-label="Page"
            aria-current-label="Page actuelle"
            @change="change"
         ></b-pagination>
      </section>
      <!-- fin pagination  -->
   </div>
</template>

<script>
import axios from 'axios';
import { BeatLoader } from '@saeris/vue-spinners';
export default {
   components: { BeatLoader },
   data() {
      return {
         loading: true,
         visites: [],
         pagination: {
            per_page: '',
            current_page: '',
            total: ''
         }
      };
   },
   mounted() {
      this.getVisites();
   },

   methods: {
      deleteVisite(id) {
         this.$buefy.dialog.confirm({
            message: 'Souhaitez-vous vraiment supprimer cette visite ?',
            cancelText: 'Non',
            confirmText: 'Oui',
            type: 'is-danger',
            onConfirm: () => {
               this.loading = true;
               axios.delete('/visites/' + id).then(res => {
                  if (res.data.erreur) {
                     this.$buefy.toast.open({
                        message: res.data.erreur,
                        type: 'is-danger'
                     });
                     this.getVisites();
                  } else {
                     this.$buefy.toast.open({
                        message: 'Visite supprimée avec succès',
                        type: 'is-success'
                     });
                     this.loading = false;
                     this.visites = this.visites.filter(visite => visite.id != id);
                  }
               });
            }
         });
      },
      change(val) {
         this.pagination.current_page = val;
         this.getVisites();
      },
      goToVisite(id) {
         this.$router.push({
            name: 'visites.edit',
            params: {
               id: id
            }
         });
      },
      async getVisites() {
         this.loading = true;
         let res = await axios.get('/ruches/' + this.$route.params.id + '/visites?page=' + this.pagination.current_page);
         this.visites = res.data.data;
         this.loading = false;
         this.pagination = res.data.meta;
      }
   }
};
</script>
